// extracted by mini-css-extract-plugin
module.exports = {"container":"l7mzO"};